var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgControlCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.59 8L6 3.42L1.41 8L-6.16331e-08 6.59L6 0.59L12 6.59L10.59 8Z",
    fill: "current"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlCloseSmall);
export default __webpack_public_path__ + "static/media/control-close-small.e7f2cb109419b4bf068470e47f7fce46.svg";
export { ForwardRef as ReactComponent };